import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import nikolaiChruchData from './data';

const NikolaiChurch = () => {
  return <ProjectDetailView data={nikolaiChruchData} />;
};

export default NikolaiChurch;
